import { createContext, useContext } from 'react'

export type IEmployeeGroupContext = {
  id: string
  name: string
  slug: string
  description: string | null
  viewerCanLeave: boolean
  viewerIsMember: boolean
  viewerIsOwner: boolean
}
export const EmployeeGroupContext = createContext<IEmployeeGroupContext | null>(
  null,
)
export const useEmployeeGroupContext = () => {
  const context = useContext(EmployeeGroupContext)
  if (!context) {
    throw new Error(
      'useEmployeeGroupContext must be used within a EmployeeGroupContext.Provider',
    )
  }
  return context
}
